export const undefinedFunctionWarning = (fnName: string) => {
    return (..._args: unknown[]): void => {
        console.warn(`function ${fnName} is not defined`);
    };
};